import { createRanking } from "services/ranking.service";
import type { CreateRankingPayload } from "types/ranking";


export function useCreateRanking() {
  const handleCreateRanking = async (payload: CreateRankingPayload) => {
    try {
      const response = await createRanking(payload);
      return response;
    } catch (error) {
      throw error;
    }
  };

  return handleCreateRanking;
}
